import { setCookie } from 'nookies';
import { Cookies } from '@/src/packages/cookies/cookies.enum';

export const hideNewsletterPopup = () => {
  setCookie(null, Cookies.HIDE_NEWSLETTER_POPUP_COOKIE, JSON.stringify(true), {
    path: '/',
    maxAge: 30 * 60 * 24 * 60,
  });
};
